import { FC, ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BodyText, Card, Modal, withStyles } from 'vopay';
import { Title, CircleButton, Button } from 'UI';
import styles from './UpgradePlanModal.module.scss';

type UpgradePlanModalProps = {
  isVisible: boolean;
  onCloseModal: () => void;
  title: string;
  ticketSubject: string;
  children: ReactNode;
  description?: string;
};

const cn = withStyles(styles);

const UpgradePlanModal: FC<UpgradePlanModalProps> = ({
  isVisible,
  onCloseModal,
  title,
  description,
  ticketSubject,
  children,
}) => {
  const history = useHistory();
  const { t } = useTranslation('translations', { keyPrefix: 'UI.UpgradePlanModal' });
  const modalContent = (
    <Modal isVisible={isVisible} enableBgClick={false}>
      <Card style={{ padding: '32px' }}>
        <div className={cn('modalContainer')}>
          <div className={cn('closeButton')}>
            <CircleButton icon="close" size="large" circleFill onClick={onCloseModal} />
          </div>
          <Title level="3">{title}</Title>
          {description && <BodyText className={cn('description')}>{description}</BodyText>}
          <div className={cn('contentContainer')}>{children}</div>

          <Button
            className={cn('button')}
            colorScheme="primary"
            onClick={() => {
              history.push({
                pathname: '/create-tickets',
                state: { ticketSubject },
              });
            }}
          >
            {t('contactSupportButton')}
          </Button>
        </div>
      </Card>
    </Modal>
  );

  const modalRoot = document.getElementById('modal-root');
  if (modalRoot) {
    return createPortal(modalContent, modalRoot);
  }
  // Fallback to body if modal-root doesn't exist
  return createPortal(modalContent, document.body);
};

export default UpgradePlanModal;
